(function() {

  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  $(document).foundation();

  jQuery(function($) {
    var newsletterPopup,
        cookieNotice,
        headerUserSearch,
        blogSearchAddFilter,
        FullscreenSlider,
        FullscreenSlider2,
        HEADER,
        PAGE,
        VideoModal,
        processSpoilers,
        addToCart,
        addToCartFail,
        addToCartPass,
        cart_dropdown_timer,
        current_window,
        fadeOutCartDropdown,
        first_article_img,
        fullscreen_slider,
        imgZoom,
        instagramFeed,
        isFirefox,
        log,
        mediaQueries,
        mobileMenu,
        mq_large,
        mq_medium,
        mq_small,
        openMobileModal,
        page_content,
        photos,
        pinterest_button,
        positions,
        productModal,
        productStickyHeader,
        recentCartItemPopUp,
        retinaLogo,
        searchAndAccount,
        selectCallback,
        slideDownCartDropdown,
        smallPromos,
        startTimer,
        headerAnnouncementBar,
        stickyHeader,
        stickyFooter,
        stopResetTimer,
        productTagFilter,
        thumbs,
        toggleCartDropdown,
        updateActiveImg,
        validateSize,
        subscribeForm,
        resizeYouTubeVideos,
        nativeVideoPlayers;
    PAGE = $('body');
    HEADER = $('.main-header');
    mq_small = 768;
    mq_medium = 1280;
    mq_large = 1440;
    log = function(value) {
      if (typeof console !== "undefined") {
        return console.log(value);
      }
    };
    headerAnnouncementBar = function() {
      var $link = $( '.tpl__header__info a' ),
          $newsletterlink = $('#newsletterlink'),
          href;
      if ($link.length > 0 && $newsletterlink.length > 0) {
        href = $link.attr('href');
        if (href === '#newsletter') {
          $link.on( 'click', function (event) {
            event.preventDefault();
            $newsletterlink.click();
          });
        }
      }
    };
    headerAnnouncementBar();
    stickyHeader = function() {
      var isPlaced = false;
      var $header = $('.tpl__header');
      var $headerContent = $('.tpl__header__content');
      var $document = $(document);
      var $window = $(window);
      var startFrom = 0;
      var handler = function() {
        startFrom = $window.height() > 800 ? 100 : 0;
        if($document.scrollTop() > startFrom && $window.width() > 1023){
          if(!isPlaced){
            isPlaced = true;
            $header.addClass('is-sticky');
            $headerContent.addClass('is-sticky');
          }
        }else{
          if(isPlaced){
            isPlaced = false;
            $header.removeClass('is-sticky');
            $headerContent.removeClass('is-sticky');
          }
        }
      };
      $window.scroll(handler);
      $window.resize(handler);
      handler();
    };
    stickyHeader();
    stickyFooter = function() {
      var header_height = $('.tpl__header').css("position") === "fixed" ? 0 : $('.tpl__header').outerHeight();
      var total_content_height = header_height + $('.main-content').outerHeight() + $('.tpl__footer').outerHeight();
      if ($(window).outerHeight() > total_content_height) {
        return $('.main-content').css({
          'min-height': $(window).outerHeight() - header_height - $('.tpl__footer').outerHeight()
        });
      }
    };
    stickyFooter();
    $(window).resize(function() {
      return stickyFooter();
    });
    productStickyHeader = function(){
      var isPlaced = false;
      var $header = $('.tpl__section.section--product-subheder');
      var $headerDummy = $('#procuct-subheader-dummy');
      var $headerButtons = $('.tpl__section.section--product-subheder .product-buttons');
      var $form = $('#product-form');
      var $formContainer = $('#product-form-container');
      var $document = $(document);
      var $window = $(window);
      var handler = function() {
        var top = (($formContainer.offset().top + $formContainer.height()) || $headerDummy.offset().top) - 48; // announcement bar
        if($document.scrollTop() >= top && $window.width() > 1023){
          if(!isPlaced){
            isPlaced = true;
            $formContainer.css('min-height', $form.height());
            $header.addClass('is-sticky');
            $headerButtons.append($form);
          }
        }else{
          if(isPlaced){
            isPlaced = false;
            $headerButtons.css('min-height', $form.height());
            $headerButtons.css('min-width', $form.width());
            $header.removeClass('is-sticky');
            $formContainer.append($form);
          }
        }
      };
      if($header.length){
        $window.scroll(handler);
        $window.resize(handler);
        handler();
      }
    };
    productStickyHeader();
    if (general_external_links_enabled) {
      $('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr('target', '_blank');
    }
    processSpoilers = function(){
      var items = [],
          isProcess = false;
      
      function show(item){
        if(item.spoiler.hasClass('is-hidden')){
          setTimeout(function(){
            item.content.css( 'height', item.contentInner.outerHeight() + 'px' );
            item.spoiler.removeClass('is-hidden');
          }, 30);
          setTimeout(function(){
            item.content.css( 'height', 'auto' );
            isProcess = false;
          }, 330);
        }
      };
      
      function hide(item){
        if(!item.spoiler.hasClass('is-hidden')){
          item.content.css( 'height', item.contentInner.outerHeight() + 'px' );
          setTimeout(function(){
            item.content.css( 'height', '0px' );
            item.spoiler.addClass('is-hidden');
          }, 30);
          setTimeout(function(){
            isProcess = false;
          }, 330);
        }
      };
      
      function toggle(item){
        if(!isProcess){
          isProcess = true;
          items.forEach(function(spoiler){
            if(spoiler !== item){
          		console.log(spoiler, item)
              hide(spoiler);
            }
          });
          if(item.spoiler.hasClass('is-hidden')){
            show(item);
          }else{
            hide(item);
          }
        }
      };
      
      var $spoilers = $('.lt__spoiler');
      $spoilers.each(function(){
        var item = {
          spoiler: $(this),
          label: $(this).find('.spoiler__label'),
          content: $(this).find('.spoiler__content'),
          contentInner: $(this).find('.spoiler__content__inner')
        };
        item.label.click(function(){
          toggle(item);
        });
        items.push(item);
      });
    };
    processSpoilers();
    subscribeForm = function() {
      window.newsletter = window.newsletter || {};
      var $forms = $('#newsletter .newsletter__container');
      // Init forms
      $forms.each(function(){
        var form = this;
        var $formC = $(form).find('.newsletter__form');
        var $form =  $(form).find('form');
        var $formB = $(form).find('.newsletter__blocks');
        var $errorC = $(form).find('.newsletter__error');
        var $successC = $(form).find('.newsletter__success');
        // Form submit event
        $form.submit(function(event){
          event.preventDefault();
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            async: true,
            success: function(response){
              if(response.status == 429){
                $errorC.text('Server error, please try again later.');
                $errorC.removeClass('hidden');
              }else{
                $formB.addClass('hidden');
                $errorC.addClass('hidden');
                $successC.removeClass('hidden');
              }
            },
          });
        });
        // Is form already sended
        if (window.newsletter.sended) {
          $formB.addClass('hidden');
          $errorC.addClass('hidden');
          $successC.removeClass('hidden');
        }
      });
    };
    subscribeForm();
    newsletterPopup = function() {
      var $popup = $('#newsletter');
      if($popup) {
        var dataSeconds = parseInt($popup.data('seconds')) || 2;
        var dataDays = parseInt($popup.data('days')) || 0;
        var cookieValue = $.cookie('popup');
        var delayTime = dataSeconds * 1000;
        var delayInt = false;
        var saveCookie = dataDays !== 0 ? true : false;
        var isOpen = false;
        var isCartPage = window.location.pathname === '/cart';
        // Methods
        var open = function(){
          isOpen = true;
          delayInt && clearTimeout(delayInt);
          if(saveCookie){
            $.cookie('popup', 'open', { expires: dataDays, path: '/' });
          }
          $popup.removeClass('display-none');
          window.requestAnimationFrame(function(){
            $popup.removeClass('hidden');
          });
          setTimeout(function(){
            var input = $popup.find('.newsletter__form input[type="text"]');
            if(input.length > 0){
          		input.get(0).focus();
            }
          }, 1000);
        };
        var close = function(){
          isOpen = false;
          $popup.addClass('hidden');
          setTimeout(function(){
            $popup.addClass('display-none');
          }, 1000);
        };
        $('#newsletter .newsletter__close').on('click', function() {
          close();
        });
        $('#newsletter .newsletter__skip .button').on('click', function() {
          close();
        });
        // SignUp Link
        $('#newsletterlink').on('click', function() {
          if($popup.hasClass('hidden')){
            open();
          }else{
            close();
          }
        });
        // Auto Open
        if(isCartPage && !isOpen && cookieValue !== 'open'){
          delayInt = setTimeout(open, delayTime);
        }
        // Hash
        if(window.location.hash === '#newsletter'){
          open();
        }
        window.addEventListener('hashchange', function(){
          if(window.location.hash === '#newsletter'){
            open();
          }
        });
      }
    };
    newsletterPopup();
    cookieNotice = function() {
      var $container = $('#cookie-notice');
      var $button = $container.find('.button');
      var cookieAccept = $.cookie('cookie-accept');
      if($container.length > 0) {
        $button.on('click', function() {
          $container.addClass('is-hidden');
          $.cookie('cookie-accept', 'true', { path: '/' });
        });
        if(cookieAccept !== 'true'){
          $container.removeClass('is-hidden');
          $container.addClass('is-visible');
        }
      }
    };
    cookieNotice();
    blogSearchAddFilter = function() {
      var author, value;
      $('#blog-search-form').on('submit', function(e) {
        author = $('#blog-search-form').data('author');
        value = e.target.q.value +' AND author:';
        if(author && value.indexOf(author) < 0){
          value += author.replace(' ', '+');
        }
      	e.target.q.value = value;
      	return true;
      });
    };
    blogSearchAddFilter();
    headerUserSearch = function() {
      var searchButton = $('.tpl__header .header__toggle .search__button'),
          searchLink =  $('.tpl__header .header__toggle .search__link'),
          searchBar =  $('.tpl__header .header__toggle .header__search'),
          searchBox =  $('.tpl__header .header__toggle .header__search .search-box'),
          isOpen = false;
      // Methods
      var open = function(){
        isOpen = true;
        searchBar.removeClass('hidden');
        searchButton.switchClass('close', 'open');
        setTimeout(function(){
        	searchBox.focus();
        }, 300);
      };
      var close = function(){
        isOpen = false;
        searchBar.addClass('hidden');
        searchButton.switchClass('open', 'close');
      };
      var toggle = function(event){
        event.preventDefault();
        if(isOpen){
          close();
        }else{
          open();
        }
      };
      searchButton.on('click', toggle);
      searchLink.on('click', toggle);
    };
    headerUserSearch();
    mobileMenu = function() {
      var mobile_menu_link = $('.tpl__header .header__bottom .menu'),
          mobile_menu = $('.tpl__header .header__mobile-menu');
      mobile_menu_link.click(function() {
        mobile_menu.toggle();
        return false;
      });
    };
    mobileMenu();
    instagramFeed = function() {
      var access_token, getImages, items_to_load, feed, items;

      access_token = home_widget_instagram_client_id; // Add your access token between the quotations

      feed = $('.instagram-widget');
      items_to_load = 6;
      if ($('.partial--instagram-feed').length > 0) {
        feed = $('.partial--instagram-feed');
        items_to_load = 12;
      }

      // exit if missing config 
      if (access_token.length < 1 || feed.length < 1) {
        return false;
      }

      // detect older versions and tidy up html
      if (feed.find('iframe').length > 0) {
        feed.find('iframe').remove();
      }
      if (feed.find('.items').length == 0) {
        feed.append('<div class="items"></div>');
      }

      items = feed.find('.items');

      // wide
      if (typeof home_widget_twitter_enabled !== 'undefined' && typeof home_widget_blog_enabled !== 'undefined') {
        if (!home_widget_twitter_enabled && !home_widget_blog_enabled) {
          items_to_load = 5;
          feed.find('.items').addClass('wide');
        }
      }

      getImages = function() {
        return $.ajax({
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + access_token + '&count=' + items_to_load,
          success: function(response) {
            var data, i, img_src, _i, _ref, _results;
            if (response.meta.code === 200) {
              data = response.data;
              _results = [];
              for (i = _i = 0, _ref = items_to_load - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
                if (data[i]) {
                  img_src = data[i].images.low_resolution.url;
                  img_src = img_src.replace("http:", "https:");
                  _results.push(items.append('<a class="item" target="_blank" href="' + data[i].link + '"><img class="lazyload" data-src="' + img_src + '" alt="Instagram" /></a>'));
                } else {
                  _results.push(void 0);
                }
              }
              return _results;
            } else {
              return items.append('<p class="error">' + response.meta.error_message + '</p><p class="colored-links">Check the <strong>Homepage - social feeds</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p>');
            }
          },
          error: function(jqXHR, textStatus) {
            console.log(jqXHR);
            return console.log(textStatus);
          }
        });
      };
      return getImages();
    };
    VideoModal = (function() {
      function VideoModal(video) {
        this.createIframe = __bind(this.createIframe, this);
        this.extractVideoId = __bind(this.extractVideoId, this);
        this.extractVideoType = __bind(this.extractVideoType, this);
        this.eventListeners = __bind(this.eventListeners, this);
        this.centerPosition = __bind(this.centerPosition, this);
        this.close = __bind(this.close, this);
        this.open = __bind(this.open, this);
        this.opened = false;
        this.video = video;
        this.modal = $('.video.modal');
        this.player_button = video.find('.player-button');
        this.src_url = video.find('.play-button').attr('href');
        this.type = this.extractVideoType();
        this.id = this.extractVideoId();
        this.iframe = this.createIframe();
        this.caption = video.find('.caption');
      }

      VideoModal.prototype.open = function() {
        this.opened = true;
        this.modal.find(".flex-video").append(this.iframe);
        if (this.caption.length > 0) {
          this.modal.find(".caption").append(this.caption.html());
          this.modal.addClass("wide");
        } else {
          this.modal.find(".player").removeClass('large-8');
          this.modal.find('.caption').hide();
          this.modal.removeClass("wide");
        }
        this.player_button.hide();
        $('.modal-mask').show();
        this.modal.find('.close').show();
        this.modal.fadeIn();
        this.centerPosition();
        $(".modal").fadeIn(0);
        return this.eventListeners();
      };

      VideoModal.prototype.close = function() {
        this.opened = false;
        this.modal.find(".flex-video").empty();
        this.modal.find(".caption").empty();
        this.modal.hide();
        $('.modal-mask').fadeOut();
        if (this.caption.length === 0) {
          this.modal.find(".player").addClass('large-8');
          return this.modal.find('.caption').show();
        }
      };

      VideoModal.prototype.centerPosition = function() {
        if ($(window).height() < this.modal.outerHeight()) {
          return this.modal.css({
            'position': 'absolute',
            'top': '30px',
            'margin-top': 0,
            'margin-left': -(this.modal.outerWidth() / 2)
          });
        } else {
          return this.modal.css({
            'position': 'fixed',
            'top': '50%',
            'margin-top': -(this.modal.outerHeight() / 2),
            'margin-left': -(this.modal.outerWidth() / 2)
          });
        }
      };

      VideoModal.prototype.eventListeners = function() {
        var modal;
        modal = this;
        this.modal.find('.close').on('click', function() {
          return modal.close();
        });
        $(window).resize(function() {
          return modal.centerPosition();
        });
        $(document).keydown(function(e) {
          if (modal.opened) {
            if (e.keyCode === 27) {
              return modal.close();
            }
          }
        });
        $('.modal-mask').on('click', function() {
          return modal.close();
        });
        return this.player_button.on('click', function() {
          return false;
        });
      };

      VideoModal.prototype.extractVideoType = function() {
        var matches, re;
        re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
        matches = re.exec(this.src_url);
        if (matches) {
          return 'youtube';
        } else {
          re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
          matches = re.exec(this.src_url);
          if (matches) {
            return 'vimeo';
          }
        }
        return false;
      };

      VideoModal.prototype.extractVideoId = function() {
        var match, regExp;
        if (this.type === 'youtube') {
          regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
          match = this.src_url.match(regExp);
          if (match && match[2].length === 11) {
            return match[2];
          }
        } else if (this.type === "vimeo") {
          regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
          match = this.src_url.match(regExp);
          if (match) {
            return match[2];
          }
        }
      };

      VideoModal.prototype.createIframe = function() {
        if (this.type === "youtube") {
          return '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>';
        } else if (this.type === "vimeo") {
          return '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        }
      };

      return VideoModal;

    })();
    productModal = function() {
      var changeModal, closeModal, modal, mask, modal_controls, modal_init, modal_length, modal_open, openModal, resizeModal;
      modal = $('.product-modal');
      mask = $('.product-modal-mask');
      if (modal.length && product_modal_enabled) {
        $( document.body ).append(modal);
        $( document.body ).append(mask);
        modal_length = $("article .photos .photo").length;
        modal_init = false;
        modal_open = false;
        modal.find('.loading').spin('small');
        if (modal_length > 1) {
          modal.addClass("with-nav");
          modal_controls = modal.find('.glyph');
        } else {
          modal_controls = modal.find('.close');
        }
        resizeModal = function() {
          var active_photo, height_ratio, image_height, image_width, width_ratio, window_height, window_width;
          active_photo = modal.find('.photo.active');
          if (active_photo.data('type') === 'external_video') {
            image_width = 1000;
            image_height = image_width / 100 * 56.25;
          } else {
            image_width = active_photo.naturalWidth();
            image_height = active_photo.naturalHeight();
          }
          window_width = $(window).width();
          window_height = $(window).height();
          width_ratio = image_width / window_width;
          height_ratio = image_height / window_height;
          if (width_ratio > height_ratio && width_ratio > .90) {
            image_width = image_width * .90 / width_ratio;
            image_height = image_height * .90 / width_ratio;
          } else if (width_ratio < height_ratio && height_ratio > .90) {
            image_width = image_width * .90 / height_ratio;
            image_height = image_height * .90 / height_ratio;
          }
          modal.css({
            'width': image_width,
            'height': image_height,
            'margin-top': -(image_height / 2),
            'margin-left': -(image_width / 2)
          });
          return active_photo.css({
            'height': image_height
          });
        };
        openModal = function(index) {
          var active_photo, $photo, $iContainer, $iInner;
          modal_open = true;
          if (!modal_init) {
            $("article .photos .photo").each(function() {
              $photo = $(this);
              if ($photo.data('type') === 'external_video') {
                $iContainer = $('<div>')
                  .attr('data-type', $photo.data('type'))
                  .addClass('pt__video photo');
                $iInner = $('<div>')
                  .addClass('inner')
                  .append($photo.find('iframe').clone())
                  .appendTo($iContainer);
              } else {
                $iContainer = $('<img>')
                  .attr('data-type', $photo.data('type'))
                  .attr('src', $photo.attr('href'))
                  .addClass('photo');
              }
              return modal.find(".slides").append($iContainer);
            });
            modal_init = true;
          }
          mask.show();
          modal.fadeIn();
          active_photo = $(".product-modal img").eq(index);
          active_photo.addClass('active');
          return modal.find(".photo.active").imagesLoaded(function() {
            modal.find(".loading").hide();
            modal_controls.show();
            modal.find(".slides").show();
            return resizeModal();
          });
        };
        $('.photos .container').on('click', function() {
          var index;
          if (current_window === 'small') {
            return false;
          }
          index = $(this).find('.photo.active').index();
          console.log(index);
          return openModal(index);
        });
        closeModal = function() {
          var active_photo = modal.find(".photo.active"),
              active_photo_src;
          modal_open = false;
          active_photo.removeClass("active");
          if (active_photo.data('type') === 'external_video') {
            active_photo_src = active_photo.find('iframe').attr('src');
            active_photo.find('iframe').attr('src', active_photo_src);
          }
          modal.css('display', 'none');
          return mask.fadeOut();
        };
        modal.find('.close').on('click', function() {
          return closeModal();
        });
        mask.on('click', function() {
          return closeModal();
        });
        changeModal = function(direction) {
          var active_index, active_photo, active_photo_src, new_index, new_photo, photo_length;
          active_photo = modal.find('.photo.active');
          active_index = modal.find('.photo.active').index();
          photo_length = modal.find('.photo').length;
          if (direction === 'prev') {
            if (active_index === 0) {
              new_index = photo_length - 1;
            } else {
              new_index = active_index - 1;
            }
          }
          if (direction === 'next') {
            if (active_index === photo_length - 1) {
              new_index = 0;
            } else {
              new_index = active_index + 1;
            }
          }
          
          active_photo.removeClass('active');
          if (active_photo.data('type') === 'external_video') {
            active_photo_src = active_photo.find('iframe').attr('src');
            active_photo.find('iframe').attr('src', active_photo_src);
          }
          modal_controls.hide();
          modal.find(".loading").delay(50).fadeIn(0);
          
          new_photo = modal.find('.photo').eq(new_index);
          return new_photo.imagesLoaded(function() {
            modal.find(".loading").stop(true, true).fadeOut(0);
            modal_controls.show();
            new_photo.addClass('active');
            return resizeModal();
          });
        };
        modal.find('.prev').on('click', function() {
          return changeModal('prev');
        });
        modal.find('.next').on('click', function() {
          return changeModal('next');
        });
        modal.find('.slides').on('click', function() {
          return changeModal('next');
        });
        $(document).keydown(function(e) {
          if (modal_open) {
            if (e.keyCode === 37 && modal_length > 1) {
              changeModal('prev');
            }
            if (e.keyCode === 39 && modal_length > 1) {
              changeModal('next');
            }
            if (e.keyCode === 27) {
              return closeModal();
            }
          }
        });
        if (modal_init) {
          return $(window).resize(function() {
            return resizeModal();
          });
        }
      }
    };
    $('.accordion.headings').each(function() {
      return $(this).add($(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
    });
    $('.accordion.headings li').wrapInner('<div class="trigger"></div>');
    $('.accordion.headings li .trigger').append('<div class="bg"></div>');
    $('.accordion-wrapper').each(function() {
      var accordion_content, accordion_heading;
      accordion_heading = $(this).find('.accordion.headings > li');
      accordion_content = $(this).find('.accordion.content > li');
      accordion_heading.first().addClass('active');
      accordion_content.each(function(index) {
        var content;
        content = $('<div class="content">' + $(this).html() + '</div>');
        return content.appendTo(accordion_heading.eq(index));
      });
      accordion_content.remove();
      $(this).find('.content').first().show();
      return $(this).find('.trigger').on("click", function() {
        var panels, this_panel;
        panels = $(this).closest(".accordion").find('.content');
        this_panel = $(this).closest("li").find(".content");
        panels.not(this_panel).slideUp(200);
        this_panel.slideDown(200, function() {
          if (general_scroll_to_active_item) {
            return $('html, body').animate({
              scrollTop: this_panel.offset().top - 100
            });
          }
        });
        $(this).closest(".accordion").find("li").removeClass("active");
        return $(this).closest("li").addClass("active");
      });
    });
    $('.tabs-horizontal.headings').each(function() {
      return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>");
    });
    $('.tabs-horizontal.headings li').wrapInner('<div class="trigger"></div>');
    $('.tabs-horizontal.headings li .trigger').append('<div class="bg"></div>');
    $('.tabs-wrapper.horizontal').each(function() {
      var tab_content, tab_headings;
      tab_headings = $(this).find('.headings > li');
      tab_content = $(this).find('.tabs.content > li');
      tab_content.first().addClass('active');
      tab_headings.first().addClass('active');
      return tab_headings.on('click', function() {
        tab_headings.removeClass('active');
        tab_content.removeClass('active');
        $(this).addClass('active');
        return tab_content.eq($(this).index()).addClass('active');
      });
    });
    $('.tabs-vertical.headings').each(function() {
      return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper vertical'/>");
    });
    $('.tabs-vertical.headings li').wrapInner('<div class="trigger"></div>');
    $('.tabs-vertical.headings li .trigger').append('<div class="bg"></div>');
    $('.tabs-wrapper.vertical').each(function() {
      var tab_content, tab_headings, tab_wrapper;
      tab_wrapper = $(this);
      tab_headings = $(this).find('.headings > li');
      tab_content = $(this).find('.tabs.content > li');
      tab_content.first().addClass('active');
      tab_headings.first().addClass('active');
      return tab_headings.on('click', function() {
        tab_headings.removeClass('active');
        tab_content.removeClass('active');
        $(this).addClass('active');
        tab_content.eq($(this).index()).addClass('active');
        if (general_scroll_to_active_item) {
          if (matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches || $("html").hasClass("lt-ie9")) {
            return $('html, body').animate({
              scrollTop: tab_wrapper.offset().top - 50
            }, 'slow');
          } else {
            return $('html, body').animate({
              scrollTop: tab_wrapper.offset().top + tab_wrapper.find('.headings').outerHeight() - 50
            }, 'slow');
          }
        }
      });
    });
    $('.cart-form').submit(function() {
      addToCart($(this));
      return false;
    });
    $('.recently-added.mobile .close').on('click', function() {
      return fadeOutCartDropdown();
    });
    $('.recently-added-mask').on('click', function() {
      return fadeOutCartDropdown();
    });
    cart_dropdown_timer = '';
    toggleCartDropdown = function() {
      return $('.tpl__header .recently-added').slideToggle('fast');
    };
    productTagFilter = function(){
      /* Product Tag Filters - Good for any number of filters on any type of collection pages */
      /* Brought to you by Caroline Schnapp */
      var collFilters = jQuery('.tags-listbox');
      collFilters.change(function() {
        var newTags = [];
        collFilters.each(function() { 
          if (jQuery(this).val()) {
            newTags.push(jQuery(this).val());
          }
        });
        if (newTags.length) {
          var query = newTags.join('+');
          window.location.href = jQuery('Liquid syntax error: invalid tag filter (unavailable in this context)').attr('href').replace('tag', query);
        } else {
          
          window.location.href = '/collections/types?q=';
          
        }
      });
    };
    productTagFilter();
    slideDownCartDropdown = function() {
      $('.tpl__header .recently-added').slideDown('fast');
      if($('.tpl__header').hasClass('is-sticky')){
        return;
      }else{
        return $("html, body").animate({scrollTop: 0});
      }
    };
    openMobileModal = function() {
      $('.tpl__header .recently-added.mobile').fadeIn();
      return $('.tpl__header .recently-added-mask').removeClass('hide');
    };
    fadeOutCartDropdown = function() {
      clearTimeout(cart_dropdown_timer);
      $('.tpl__header .recently-added').fadeOut('fast');
      return $('.tpl__header .recently-added-mask').addClass('hide');
    };
    $('.tpl__header .recently-added').mouseenter(function() {
      return stopResetTimer();
    });
    $('.tpl__header .recently-added').mouseleave(function() {
      return startTimer();
    });
    startTimer = function() {
      return cart_dropdown_timer = setTimeout((function() {
        return fadeOutCartDropdown();
      }), 4000);
    };
    stopResetTimer = function() {
      return clearTimeout(cart_dropdown_timer);
    };
    validateSize = function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    };
    addToCart = function($form) {
      var idValue,
          _targetProductId = 'test',	// Strengthener 2.0 - Safe Effective Formulation
          _addProductId = '29448965783617',		// Maxus Nail File 180/240 Grit - Individually wrapped 
          $idInput = $form.find( 'input[name="id"], select[name="id"]' ),
          data = $form.serialize();
      
      if ( $idInput.length > 0 ) {
        idValue = $idInput.val();
    
        // If current product == target, add addition product to cart
    	if ( idValue === _targetProductId ) {
          data = {
            items: [
              {
                quantity: 1,
                id: _addProductId
              },
              {
                quantity: 1,
                id: _targetProductId
              }
            ]
          };
        }
      }
      
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        success: addToCartPass,
        error: addToCartFail
      });
    };
    addToCartPass = function(product) {
      return recentCartItemPopUp(product);
    };
    addToCartFail = function(obj, status) {
      $('.recently-added .error').show();
      $('.recently-added table').hide();
      $('.recently-added div.row').hide();
      slideDownCartDropdown();
      return startTimer();
    };
    recentCartItemPopUp = function(product) {
      var cart_item, cart_total, currency_symbol;
      cart_item = {};
      cart_total = {};
      currency_symbol = $('.actual-price').html();
      currency_symbol = $.trim(currency_symbol.slice(0, currency_symbol.search(/\d/)));
      Shopify.money_format = currency_symbol + " {{amount}}";
      return $.getJSON("/cart.js", function(cart, textStatus) {
        var current_raw_total, item, new_cart_row, new_mobile_item, _i, _len, _ref;
        
        current_raw_total = parseInt($('.recently-added .raw-total').html()) * 100;
        cart_total.quantity = 0;
        cart_total.price = 0;
        _ref = cart.items;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          item = _ref[_i];
          cart_total.quantity += item.quantity;
          cart_total.price += item.price * item.quantity;
        }
        $('.cart-link .number').html(cart_total.quantity);
        $('.cart-link .number-wrapper').removeClass('hide');
        $('.recently-added .items-count .number').html(cart_total.quantity);
        $('.recently-added .total-price').html(Shopify.formatMoney(cart_total.price, Shopify.money_format));

        cart_item.image_url = Shopify.resizeImage(product.image, "small");
        cart_item.url = product.url;
        cart_item.title = product.title;
        cart_item.price_raw = product.price;
        cart_item.price = Shopify.formatMoney(cart_item.price_raw, Shopify.money_with_currency_format);
        
        new_cart_row = '<tr>';
        new_cart_row += '<td class="cart-item">';
        new_cart_row += '<a href="' + cart_item.url + '">';
        new_cart_row += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_cart_row += '</a>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-detail" colspan="2">';
        new_cart_row += '<h2><a href="' + cart_item.url + '">' + cart_item.title + '</a></h2>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-price">' + cart_item.price + '</td>';
        new_cart_row += '</tr>';
        new_mobile_item = '<a href="' + cart_item.url + '">';
        new_mobile_item += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_mobile_item += '</a>';
        $('.recently-added tbody').html(new_cart_row);
        $('.recently-added .mobile-item').html(new_mobile_item);
        
        $('.recently-added .error').hide();
        $('.recently-added table').show();
        $('.recently-added div.row').show();
        if ($('.tpl__header .header__bottom').is(":hidden")) {
          slideDownCartDropdown();
        } else {
          openMobileModal();
        }
        return startTimer();
      });
    };
    resizeYouTubeVideos = function(){
      /* resize all videos */
      // Find all YouTube videos
      var $allVideos = $("iframe[src^='//www.youtube.com']"),
          // The element that is fluid width
          $fluidEl = $("body");
      // Figure out and save aspect ratio for each video
      $allVideos.each(function() {
        $(this)
          .data('aspectRatio', this.height / this.width)
          // and remove the hard coded width/height
          .removeAttr('height')
          .removeAttr('width');
      });
      // When the window is resized
      $(window).resize(function() {
        var newWidth = $fluidEl.width();
        // Resize all videos according to their own aspect ratio
        $allVideos.each(function() {
          var $el = $(this);
          $el
            .width(newWidth)
            .height(newWidth * $el.data('aspectRatio'));

        });
      // Kick off one resize to fix all videos on page load
      }).resize();
    };
    resizeYouTubeVideos();
    nativeVideoPlayers = function() {
      var $videos = $('.pt__video.is-native');
      $videos.each(function(){
        new VideoPlayer(this);
      }); 
    };
    nativeVideoPlayers();
    if (PAGE.hasClass('template-index')) {
      new PageLanding(document.body);
    }
    if (PAGE.hasClass('page-frequently-asked-questions')) {
      new PageFAQ(document.body);
    }
    if (PAGE.hasClass('template-page')) {
      page_content = $('.page-content .rte-content');
      if (page_content.find('.left-side-column').length || page_content.find('.right-side-column').length) {
        if (page_content.find('.left-side-column').length && page_content.find('.right-side-column').length) {
          page_content.wrapInner("<div class='main-column with-2-sidebars'></div>");
          $('.left-side-column').addClass('with-2-sidebars');
          $('.right-side-column').addClass('with-2-sidebars');
        } else {
          page_content.wrapInner("<div class='main-column'></div>");
        }
        $('.left-side-column').prependTo(page_content);
        $('.right-side-column').appendTo(page_content);
      }
    }
    if (PAGE.hasClass('page-why-maxus')) {
      FullscreenSlider = (function() {
        function FullscreenSlider(slider_element, autoplay_enabled, autoplay_frequency) {
          this.eventListeners = __bind(this.eventListeners, this);
          this.alignPlayButton = __bind(this.alignPlayButton, this);
          this.alignCaption = __bind(this.alignCaption, this);
          this.getActiveIndex = __bind(this.getActiveIndex, this);
          this.autoplay = __bind(this.autoplay, this);
          this.createSlider = __bind(this.createSlider, this);
          this.el = slider_element;
          this.autoplay_enabled = autoplay_enabled;
          this.autoplay_frequency = autoplay_frequency;
          this.createSlider();
          this.owl = $(".owl-carousel").data('owlCarousel');
        }

        FullscreenSlider.prototype.createSlider = function() {
          var slider;
          slider = this;
          return slider.el.owlCarousel({
            singleItem: true,
            navigation: false,
            paginationNumbers: false,
            scrollPerPageNav: true,
            slideSpeed: 800,
            pagination: true,
            autoHeight: true,
            autoPlay: slider.autoplay(),
            afterInit: function() {
              return slider.eventListeners();
            },
            afterAction: function() {
              slider.alignCaption();
              return slider.alignPlayButton();
            }
          });
        };

        FullscreenSlider.prototype.autoplay = function() {
          if (this.autoplay_enabled) {
            return this.autoplay_frequency;
          }
          return false;
        };

        FullscreenSlider.prototype.getActiveIndex = function() {
          return this.el.find('.owl-pagination .owl-page.active').index();
        };

        FullscreenSlider.prototype.alignCaption = function() {
          var caption, caption_height, caption_width, slide, slide_padding, top_offset;
          slide = this.el.find('.owl-item').eq(this.getActiveIndex());
          caption = slide.find('.caption');
          caption.css('visibility', 'hidden');
          caption_height = caption.outerHeight();
          caption_width = caption.outerWidth();
          slide_padding = 30;
          if (PAGE.hasClass('transparent-menu')) {
            top_offset = $('.main-header').outerHeight();
          } else {
            top_offset = 0;
          }
          return slide.find('img').first().imagesLoaded(function() {
            var left_offset, middle_top, slide_height, slide_width;
            slide_height = slide.outerHeight();
            slide_width = slide.outerWidth();
            if (caption.hasClass('top')) {
              caption.css('top', top_offset + slide_padding);
            } else if (caption.hasClass('middle')) {
              middle_top = top_offset + (slide_height - top_offset - caption_height) / 2;
              caption.css('top', middle_top);
            }
            if (caption.hasClass('center')) {
              left_offset = (slide_width - caption_width) / 2;
              caption.css('left', left_offset);
            }
            return caption.css('visibility', 'visible');
          });
        };

        FullscreenSlider.prototype.alignPlayButton = function() {
          var play_button, slide;
          slide = this.el.find('.owl-item').eq(this.getActiveIndex());
          play_button = slide.find('.play-button');
          play_button.css('visibility', 'hidden');
          if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
            slide.find('img').first().imagesLoaded(function() {
              var play_button_height, slide_height, video_offset;
              slide_height = slide.outerHeight();
              play_button_height = play_button.outerHeight();
              video_offset = (slide_height - play_button_height) / 2;
              return play_button.css({
                'margin-top': 0,
                'top': video_offset
              });
            });
          } else {
            play_button.css({
              'margin-top': '-40px',
              'top': '50%'
            });
          }
          return play_button.css('visibility', 'visible');
        };

        FullscreenSlider.prototype.eventListeners = function() {
          var slider;
          slider = this;
          this.el.find(".play-button").on('click', function() {
            var video_modal;
            video_modal = new VideoModal($(this).closest('.video'));
            video_modal.open();
            slider.owl.stop();
            return false;
          });
          return this.el.find('.owl-pagination .owl-page').on('click', function() {
            return slider.owl.stop();
          });
        };

        return FullscreenSlider;

      })();
      fullscreen_slider = new FullscreenSlider($('.slider .slides'), home_slider_auto_enabled, home_slider_rotate_frequency);
      $('.product-slider').slice(1).css('padding-top', 0);
      $('.product-slider .product-grid').owlCarousel({
        items: 4,
        navigation: true,
        scrollPerPage: true,
        slideSpeed: 800,
        lazyLoad: true,
        pagination: false,
        navigationText: false
      });
      $('.product-slider .product-item').show();
      smallPromos = function() {
        return $('.small-promos .image-text-widget').mouseenter(function() {
          return $(this).find('.caption').fadeIn(300);
        }).mouseleave(function() {
          return $(this).find('.caption').stop(true, true).fadeOut(300);
        });
      };
      smallPromos();
      instagramFeed();
    }
        FullscreenSlider2 = (function() {
          function FullscreenSlider2(slider_element, autoplay_enabled, autoplay_frequency, transition_style) {
            this.eventListeners = __bind(this.eventListeners, this);
            this.alignPlayButton = __bind(this.alignPlayButton, this);
            this.alignCaption = __bind(this.alignCaption, this);
            this.getActiveIndex = __bind(this.getActiveIndex, this);
            this.autoplay = __bind(this.autoplay, this);
            this.createSlider = __bind(this.createSlider, this);
            this.el = slider_element;
            this.autoplay_enabled = autoplay_enabled;
            this.autoplay_frequency = autoplay_frequency;
            this.transitionStyle = transition_style;
            this.createSlider();
            this.owl = $(".owl-carousel").data('owlCarousel');
          };

          FullscreenSlider2.prototype.autoplay = function() {
            if (this.autoplay_enabled) {
              return this.autoplay_frequency;
            }
            return false;
          };

          FullscreenSlider2.prototype.createSlider = function() {
            var slider;
            slider = this;
            return slider.el.owlCarousel({
              singleItem: true,
              navigation: false,
              paginationNumbers: false,
              scrollPerPageNav: true,
              slideSpeed: 800,
              pagination: true,
              autoHeight: true,
              transitionStyle: slider.transitionStyle,
              autoPlay: slider.autoplay(),
              afterInit: function() {
                return slider.eventListeners();
              }
            });
          };

          FullscreenSlider2.prototype.eventListeners = function() {
            var slider;
            slider = this;
            return this.el.find('.owl-pagination .owl-page').on('click', function() {
              return slider.owl.stop();
            });
          };

          return FullscreenSlider2;

        })();
        var $sliders = $('.lt__slider');
        $sliders.each(function(){
          var auto_enabled = $(this).attr('data-auto-enabled');
          var rotate_frequency = $(this).attr('data-rotate-frequency');
          var transition_style = $(this).attr('data-transition-style');
          var slider = $(this).find('.slides');
          new FullscreenSlider2(slider, auto_enabled, rotate_frequency, transition_style);
        });
    if (
      PAGE.hasClass('template-list-collections') ||
      PAGE.hasClass('page-nails-collections')
    ) {
      $('.collection-item').mouseenter(function() {
        return $(this).find('.caption').fadeIn(300);
      }).mouseleave(function() {
        return $(this).find('.caption').stop(true, true).fadeOut(300);
      });
    }
    if (PAGE.hasClass('template-product')) {
      positions = function() {
        var insertPosition;
        insertPosition = function(position_target) {
          var positions_src, target;
          positions_src = $('.positions.active');
          target = position_target;
          positions_src.find('[data-position]').each(function() {
            var elem_src, elem_target, position;
            position = $(this).attr('data-position');
            if (position.length) {
              elem_src = positions_src.find('[data-position="' + position + '"]');
              elem_target = target.find('[data-position="' + position + '"]');
              return elem_src.children().appendTo(elem_target);
            }
          });
          positions_src.removeClass('active');
          return position_target.addClass('active');
        };
        $(document).on("smallWindow", function() {
          return insertPosition($('.positions.show-for-small'));
        });
        $(document).on("mediumWindow", function() {
          return insertPosition($('.positions.show-for-medium-only'));
        });
        $(document).on("largeWindow", function() {
          return insertPosition($('.positions.show-for-large-up'));
        });
      };
      positions();
      photos = $('article .photos');
      thumbs = $('article .thumbs');
      photos.on('click', function() {
        return false;
      });
      imgZoom = function(index) {
        if (Modernizr.touch === false && product_zoom_enabled) {
          return photos.find('.container').zoom({
            url: photos.find('.photo').eq(index).attr('data-zoom')
          });
        }
      };
      if (Modernizr.touch === false && product_zoom_enabled) {
        photos.find('.container').on("mouseover", function() {
          $(this).css('outline-width', 1);
          return photos.find('.zoomImg').css({
            opacity: 1
          });
        }).on("mouseleave", function() {
          return $(this).css('outline-width', 0);
        });
      }
      updateActiveImg = function(index) {
        var transition_time,
            $photoContainer = photos.find('.container'),
            $photo = photos.find('.photo').eq(index),
            $activePhoto = photos.find('.photo.active');
        
        if ($photo.find('img,iframe').length < 1) {
          return;
        }
        if ($activePhoto.index() === index) {
          return;
        }
        
        thumbs.find('.thumb').removeClass('active');
        thumbs.find('.thumb').eq(index).addClass('active');
        photos.find('.zoomImg').remove();
        
        transition_time = 0;
        if ($activePhoto.length) {
          transition_time = 300;
          $activePhoto
          	.fadeOut(transition_time)
          	.removeClass('active')
          	.queue(function(next){
              if ($activePhoto.data('type') === 'external_video') {
                var videoSrc = $activePhoto.find('iframe').attr('src');
                $activePhoto.find('iframe').attr('src', videoSrc);
              }
              next();
            });
        }
        
        if ($photo.data('type') === 'external_video') {
          $photo
          	.delay(transition_time)
          	.queue(function(next) {
              var containerWidth = photos.outerWidth(),
                  width = containerWidth,
                  height = width / 100 * 56.25;
              $photoContainer.animate({"height": height, "width": width}, transition_time, function() {
                return $photoContainer.css({
                  'height': 'auto',
                  'width': 'auto'
                });
              });
              $photo.addClass('active').fadeIn(transition_time);
              next();
            });
        } else {
          $photo
          	.delay(transition_time)
          	.imagesLoaded(function() {
              var containerWidth, height, width;
              imgZoom(index);
              height = $photo.find('img').naturalHeight();
              width = $photo.find('img').naturalWidth();
              containerWidth = photos.outerWidth();
              if (containerWidth < width) {
                height = containerWidth / width * height;
                width = containerWidth;
              }
              $photoContainer.animate({"height": height,"width": width}, transition_time, function() {
                return $photoContainer.css({
                  'height': 'auto',
                  'width': 'auto'
                });
              });
              return $photo.addClass('active').fadeIn(transition_time);
            });
        }
      };
      thumbs.find('.thumb').click(function() {
        return updateActiveImg($(this).index());
      });
      // selectCallback - Triggered each time a variant is selected on the Product page;
      selectCallback = function(variant, selector) {
        var variant_image_index;
        $(".compare-price").html("");
        if (variant && variant.available) {
          $(".quanity-cart-row").show();
          $('.product-unavailable').hide();
        } else {
          $(".quanity-cart-row").hide();
          $('.product-unavailable').show();
          if (product_variant_size > 1 && variant) {
            $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title);
          }
        }
        if (variant) {
          $(".actual-price").html(Shopify.formatMoney(variant.price, shop_money_format));
          if (variant.compare_at_price > variant.price) {
            $(".compare-price").html(product_language_was + " " + Shopify.formatMoney(variant.compare_at_price, shop_money_format));
          }
          if (variant.featured_image) {
            variant_image_index = $('article .photos .photo[data-image-id="' + variant.featured_image.id + '"]').index();
            updateActiveImg(variant_image_index);
          } else {
            updateActiveImg(0);
          }
        } else {
          updateActiveImg(0);
        }
      };
      // end of selectCallback;
      if($('#variant-listbox').length > 0){
        new Shopify.OptionSelectors("variant-listbox", {
          product: product_json,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }else{
        selectCallback();
      }
      $(".custom.dropdown").hide();
      if (product_options_size === 1 && product_options_first !== "Title") {
        $(".selector-wrapper:eq(0)").prepend("<label>" + product_options_first + "</label>");
      }
      $(".selector-wrapper .single-option-selector").each(Foundation.libs.forms.append_custom_select);
      $("select.single-option-selector").change(function() {
        Foundation.libs.forms.refresh_custom_select($(this), true);
      });
      productModal();
    }
    if (PAGE.hasClass('template-article')) {
      pinterest_button = $('.social-share .pinterest');
      first_article_img = $('.article img').first().attr('src');
      pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img);
    }
    current_window = '';
    mediaQueries = function() {
      if ($("html").hasClass("lt-ie9")) {
        $.event.trigger("mediumWindow");
        return current_window = 'medium';
      } else if (window.matchMedia('only screen and (min-width: ' + mq_medium + 'px)').matches) {
        if (current_window !== 'large') {
          $.event.trigger("largeWindow");
          return current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
        if (current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return current_window = 'medium';
        }
      } else {
        if (current_window !== 'small') {
          $.event.trigger("smallWindow");
          return current_window = 'small';
        }
      }
    };
    mediaQueries();
    $(window).resize(function() {
      return mediaQueries();
    });
    return $('.hide-until-js').show();
  });

  return false;

}).call(this);
